import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Tooltip, { POSITION } from 'gnos-tooltip'

import TooltipContent from './components/TooltipContent'

import './style.scss'

export default class Signals extends PureComponent {
    static propTypes = {
        caution: PropTypes.number,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        notice: PropTypes.number,
        risk: PropTypes.number,
        showZeroValues: PropTypes.bool,
    }

    static defaultProps = {
        caution: 0,
        notice: 0,
        risk: 0,
        showZeroValues: false,
    }

    render() {
        const { caution, notice, risk, showZeroValues, id } = this.props

        if (risk === 0 && caution === 0 && notice === 0 && !showZeroValues) return null

        return (
            <div className={'table-cell-signals'}>
                <Tooltip
                    content={<TooltipContent />}
                    id={`signals-tooltip-${id}-${Math.random()}`}
                    width={'350px'}
                    position={POSITION.TOP}
                    showDelay={1000}
                    automaticAlignChange
                    doubleWrap
                >
                    <div className={'table-cell-signals'}>
                        {(risk || showZeroValues) && <div className={'type-risk'}>{`x ${risk}`}</div>}
                        {(caution || showZeroValues) && <div className={'type-caution'}>{`x ${caution}`}</div>}
                        {(notice || showZeroValues) && <div className={'type-notice'}>{`x ${notice}`}</div>}
                    </div>
                </Tooltip>
            </div>
        )
    }
}
